module.exports = _.extend(
    require('./agents'), {

    bucketGuardsBg: {
        texture: '/img/partials/bucket-guards/bucket-guards-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    bucketUnder: {
        texture: '/img/partials/bucket-guards/bucket-under.png',
        position: {
            x: '0%',
            y: '20%'
        },
        scale: {
            x: '100%'
        }
    },

    bucketOver: {
        texture: '/img/partials/bucket-guards/bucket-over.png',
        position: {
            x: '0%',
            y: '20%'
        },
        scale: {
            x: '100%'
        }
    }
});



// WEBPACK FOOTER //
// ./js/objects/partials/bucketGuards.js